import { fetchStocks } from "./inventoryAction";
import { formatData } from "./utils";

// export function fetchResas(){
//     console.log("FIRED ACTION FETCH RESERVATIONS" )
//     return async function(dispatch, getState){
//         dispatch({
//             type: "FETCH_RESERVATIONS_START",
//             payload: ""
            
//         })
//         // let managerID = getState().auth.user.id
//         try {
//             const response = await fetch('/stocks/getList',{
//                 method:'POST',
//                 headers: { 
//                     'Content-Type': 'application/json',
//                     //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
//                 },
//                 body:JSON.stringify({
//                     page:`resas/demands`,
//                     // page:`resas/${managerID}`,
//                 }),
//                 credentials: 'same-origin',
//             }); 
            
//             const resasList = await response.json()
//             console.log({resasList}, !resasList)// resasList returns new object created

//             if(!resasList.error){ // no errors, return new Object
//                 console.log('=================no error===================');
//                 console.log();
//                 console.log('====================================');
//                 dispatch( getResas(formatData(resasList.reverse())) )
//                 dispatch({ type: "FETCH_RESERVATIONS_FULFILLED", payload:"" })
//                 console.log("resas fetched")
                
//                 // dispatch(fetchStocks())
            
//             } else {
//                 dispatch({
//                     type: "FETCH_RESERVATIONS_ERROR",
//                     payload: resasList.error.message
//                 })
//             }
            
//         } catch (err) {
//             dispatch({
//                 type: "FETCH_RESERVATIONS_ERROR",
//                 payload: err
                
//             })
//         }
//     }
// }
export function createResaDemand(newResa, page = "resas/demand/new"){
    console.log("FIRED ACTION CREATE RESA_DEMAND", newResa)
    return async function(dispatch){
        dispatch({
            type: "CREATE_RESA_DEMAND_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data:newResa
                }),
                credentials: 'same-origin',
            }); 
            
            const createdResa = await response.json()
            console.log(createdResa)// createdResa returns new object created

            if(createdResa.id || createdResa.resa_demand_id){ // no errors, return new Object
                dispatch({
                    type:"NEW_RESA_DEMAND",
                    payload: createdResa
                })
                dispatch({ type: "CREATE_RESA_DEMAND_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "CREATE_RESA_DEMAND_ERROR",
                    payload: createdResa.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create resa", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_RESA_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}
export function makeResa(newResa, page = "resas/new"){
    console.log("FIRED ACTION CREATE RESERVATION", newResa)
    return async function(dispatch){
        dispatch({
            type: "CREATE_RESERVATION_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data:newResa
                }),
                credentials: 'same-origin',
            }); 
            
            const createdResa = await response.json()
            console.log(createdResa)// createdResa returns new object created

            if(createdResa.resa_demand_id){ // no errors, return new Object
                dispatch({
                    type:"NEW_RESERVATION",
                    payload: createdResa
                })
                dispatch({ type: "CREATE_RESERVATION_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())
                return "OK"
            }
            dispatch({
                type: "CREATE_RESERVATION_ERROR",
                payload: createdResa.error.message
            })
            throw new Error(createdResa.error.message)
        } catch (err) {
            console.log('====================================');
            console.log("error create resa", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_RESERVATION_ERROR",
                payload: err
                
            })
            throw err;
        }
    }
}
export function createSaleFromResa(newResa, page = "resas/sale/new"){
    console.log("FIRED ACTION CREATE RESERVATION", newResa)
    return async function(dispatch){
        dispatch({
            type: "CREATE_SALE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data: newResa
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSale = await response.json()
            console.log(createdSale)// createdSale returns new object created

            if(createdSale.id){ // no errors, return new Object
                dispatch({
                    type:"NEW_SALE",
                    payload: createdSale
                })
                dispatch({ type: "CREATE_SALE_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())

                // update resa status 
               dispatch({ type: "DELETE_RESERVATION", payload: newResa.id })

            
            } else {
                dispatch({
                    type: "CREATE_SALE_ERROR",
                    payload: createdSale.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create resa", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_SALE_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteResa(resa){
    return async function(dispatch){
        dispatch({ type: "DELETE_RESERVATION_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type:"resa",
                    data:resa
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE RESERVATION RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_RESERVATION", payload: resa.op_id })
                dispatch({ type: "DELETE_RESERVATION_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return "OK"
            } else {
                dispatch({
                    type: "DELETE_RESERVATION_ERROR",
                    payload: body.error.message
                })
            }
            throw new Error(body.error.message)
        } catch (err) {
            dispatch({  type: "DELETE_RESERVATION_ERROR", payload: err })
            throw err
        }
    }
}
export function getResas(resas){
    
    return {
        type: "GET_RESERVATIONS",
        payload: resas
    }
}


export function getResa(resa_Id){
    // console.log("FIRED ACTION GET RESERVATIONS", resas)
    return {
        type: "GET_RESERVATION",
        payload: resa_Id
        
    }
}